import styled from '@emotion/styled';
import { Typography } from 'antd';

export const SContainer = styled.div`
  width: 460px;
  height: 693px;
  margin: 30px auto;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SIconWrapper = styled.div`
  width: 70px;
  height: 70px;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const SText = styled(Typography.Text)`
  font-size: 24px;
  margin-top: 29px;
  line-height: 32px;
`;
